module.exports = __webpack_public_path__ + "static/media/trimex_suprema.5c8fe7dc.png";